import * as React from 'react';
import { Formik, Form, Field } from 'formik';
import { Button, LinearProgress } from '@material-ui/core';
import { TextField} from 'formik-material-ui';
import Grid from "@material-ui/core/Grid/Grid";
import Alert from "@material-ui/lab/Alert/Alert";
import { makeStyles } from '@material-ui/core/styles';
import {blue} from "@material-ui/core/colors/index";
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl'
import {serverRootUrl} from "./../../config";
import DeleteIcon from '@material-ui/icons/Delete';
import FormHelperText from "@material-ui/core/FormHelperText/FormHelperText";
import Input from "@material-ui/core/Input/Input";
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import Rating from "@material-ui/lab/Rating/Rating";
import Typography from "@material-ui/core/Typography/Typography";

const useStyles = makeStyles((theme) => ({
    loading: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: 50
    },
    avatar: {
        backgroundColor: blue[500],
    },
    formControl: {
        width: '100%',
    },
    lastImage: {
        marginBottom: 30,
        borderBottom: '1px solid #ccc',
        borderRadius: 10
    }
}));

let setFormSubmitting;

export default function AddLpReviewForm(props) {

    const classes = useStyles();

    const [rating, setRating] = React.useState();
    let [images, setImages] = React.useState([]);

    const addImage = () => {
        let newImages = images.concat();
        newImages.push({
            id: null,
            image: null,
            description: ''
        });
        setImages(newImages);
    };

    const deleteImage = (index) => {
        let newImages = images.concat();
        delete newImages[index];
        setImages(newImages);
    };

    const onImageChange = (e, index) => {
        const files = e.target.files;

        if (files.length > 1) {
            let extraImages = [];
            for (let i=0; i<files.length; i++) {
                const file = files[i];
                loadFile(file, result => {
                    extraImages.push({
                        id: null,
                        image: result,
                        description: ''
                    });
                    if (extraImages.length === files.length) {
                        let newImages = images.concat();
                        newImages = newImages.concat(extraImages);
                        setImages(newImages);
                    }
                });
            }
        } else {
            const reader = new FileReader();

            const file = files[0];

            loadFile(file, result => {
                let newImages = images.concat();
                newImages[index].image = result;
                setImages(newImages);
            });
        }
    };

    const loadFile = (file, onLoad) => {
        const reader = new FileReader();

        reader.onload = function(upload) {
            onLoad(upload.target.result);
        };
        reader.readAsDataURL(file);
    }

    const onDescriptionChange = (e, index) => {
        let newImages = images.concat();
        newImages[index].description = e.target.value;
        setImages(newImages);
    }

    const CustomFileUpload = (props) => (
        <FormControl>
            {props.label && (
                <InputLabel shrink error={!!props.form.error}>
                    {props.label}
                </InputLabel>
            )}
            <Input
                error={!!props.form.error}
                inputProps={{
                    type: 'file',
                    multiple: props.multiple,
                    disabled: props.disabled || props.form.isSubmitting,
                    name: props.field.name,
                    onChange: (event) => {
                        const file = event.currentTarget.files[0];
                        props.form.setFieldValue(props.field.name, file);
                        props.onChange(event);
                    },
                }}
            />
            {props.form.error && (
                <FormHelperText error>{props.form.error}</FormHelperText>
            )}
        </FormControl>
    )

    return (
            <>
                {props.requestError ? <>{setFormSubmitting(false)}<Alert severity="warning">{props.requestError.toString()}</Alert><p></p></> : ''}
                <Formik
                    initialValues={{
                    }}
                    validate={values => {
                        const errors = {};


                        return errors;
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        setFormSubmitting = setSubmitting;
                        props.sendRequest({ variables: {
                                lp: props.lp,
                                description: values.description,
                                images: images,
                                rating: parseInt(rating),
                                name: values.name,
                                email: values.email
                            }});
                    }}
                >
                    {({ submitForm, isSubmitting }) => (
                        <Form>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <Field className={classes.formControl}
                                           component={TextField}
                                           type="name"
                                           label="Name"
                                           name="name"
                                           disabled={isSubmitting}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Field className={classes.formControl}
                                           component={TextField}
                                           type="email"
                                           label="Email"
                                           name="email"
                                           disabled={isSubmitting}
                                    />

                                </Grid>
                                <Grid item xs={12}>
                                    <br/><br/>
                                    <Field className={classes.formControl}
                                           component={TextField}
                                           name="description"
                                           type="description"
                                           label={props.isComment ? 'Comment' : 'Review'}
                                           multiline
                                           rows={8}
                                           rowsMax={8}
                                           variant={"outlined"}
                                           disabled={isSubmitting}
                                    />
                                    <br/>
                                    <br/>
                                </Grid>

                                <Grid item sm={6}>
                                    <Typography component="legend">Your rating out of 10</Typography>
                                </Grid>
                                <Grid item sm={6}>
                                    <Rating disabled={isSubmitting} size={props.isMobile || props.isPopup ? "normal" : "large"} name="customized-10"
                                            onChange={(e) => setRating(e.target.value)}

                                            max={10} />
                                </Grid>

                                {images.map((im, index) => {
                                    return <>

                                            <Grid item xs={12}>
                                                {im.image ?
                                                    <img src={im.image.indexOf('base64') !== -1
                                                        ? im.image
                                                        : serverRootUrl + '/' + im.image} width={"100%"}/>
                                                    : ''}
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Field
                                                    className={classes.formControl}
                                                    name={"images["+index+"]"}
                                                    variant={"outlined"}
                                                    component={CustomFileUpload}
                                                    multiple={index === images.length - 1}
                                                    onChange={e => onImageChange(e, index)}
                                                />
                                            </Grid>

                                            <Grid  item xs={6}>
                                                <Button variant="contained" color="secondary"
                                                        onClick={() => deleteImage(index)}>
                                                    <DeleteIcon/>
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12} className={classes.lastImage}>
                                                <Field className={classes.formControl}
                                                       component={TextField}
                                                       type="title"
                                                       label="Photo Description"
                                                       name={"imageDescription["+index+"]"}
                                                       onChange={e => onDescriptionChange(e, index)}
                                                       defaultValue={im.description}
                                                />
                                            </Grid>

                                    </>
                                })}
                                <Grid item xs={12}>
                                    <br />
                                    <Button variant="contained" color="primary" onClick={addImage}>
                                        <PhotoCameraIcon/>
                                    </Button>
                                </Grid>

                            </Grid>

                            {isSubmitting && <><p></p><LinearProgress /></>}
                            <br /><br />
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={isSubmitting}
                                onClick={submitForm}
                            >
                                Submit
                            </Button>
                            <br />
                            <br />
                        </Form>
                    )}
                </Formik>
            </>
    );
}